Ext.define('PanelWizardFilterTypyPojazdow', {
    extend: 'Ext.panel.Panel',
    initComponent: function () {
        this.cid = Ext.id();
        Ext.apply(this, {
            layout: "fit",
            frame: false,
            border: false,
            autoWidth: false,
            autoHeight: false,
            items: [{
                xtype: 'form',
                frame: false,
                border: false,
                autoWidth: true,
                autoHeight: true,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0"
                },
                id: this.cid + "formpanel",
                labelWidth: 100,
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1.0,
                        layout: 'form',
                        labelWidth: 100,
                        defaults: {
                            anchor: "0"
                        },
                        frame: false,
                        border: false,
                        items: [{
                            id: this.cid + "WEWNETRZNY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_pojazdow[0].capitalise()
                        }, {
                            id: this.cid + "ZEWNETRZNY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_pojazdow[1].capitalise()
                        }]
                    }]
                }]
            }]
        });
        this.callParent(arguments);
    },
    callAfterShow: function () {
        var t0 = Ext.getCmp(this.cid + "WEWNETRZNY");
        var t1 = Ext.getCmp(this.cid + "ZEWNETRZNY");
        var bbem = this.datad.mainCtrl.repDef.typyPojazdow.length == 0;
        t0.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyPojazdow, Const.TYP_POJAZDU_WEWNETRZNY) || bbem);
        t1.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyPojazdow, Const.TYP_POJAZDU_ZEWNETRZNY) || bbem);

        this.callAfterShowCalled = true;
    },
    callAfterHide: function () {
        if (this.callAfterShowCalled) {
            var t0 = Ext.getCmp(this.cid + "WEWNETRZNY");
            var t1 = Ext.getCmp(this.cid + "ZEWNETRZNY");
            this.datad.mainCtrl.repDef.typyPojazdow = [];
            if (t0.getValue())
                this.datad.mainCtrl.repDef.typyPojazdow.push(Const.TYP_POJAZDU_WEWNETRZNY);
            if (t1.getValue())
                this.datad.mainCtrl.repDef.typyPojazdow.push(Const.TYP_POJAZDU_ZEWNETRZNY);
        }
        return null;
    },
    setData: function (datad) {
        this.datad = datad;
    }
});
